import React from 'react';
import SiteLogo, {
  SiteLogoProps,
} from '@resources/js/components/SiteLogo/SiteLogo';

export default function EnhancedMarkdownSiteLogo(
  props: SiteLogoProps
): JSX.Element {
  return <SiteLogo {...props} />;
}
